import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, sendPasswordResetEmail } from "../../firebase-config";
import { NavLink, useNavigate } from "react-router-dom";
import "./login.css";

import SignUp from "../../images/Signup.png";
import { setLoggedInUser } from "./redux/actions";
import { useDispatch } from "react-redux";
import Button from "../Shared/Button";
import useScrollTo from "../../hooks/useScrollTo";
import { getUserByEmail, getUserByUserId } from "../../Datahandler";

const Login = ({ setLoggedIn }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  useScrollTo();

  const onLogin = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        getUserByEmail(userCredential.user.email).then((res) => {
          dispatch(setLoggedInUser({ ...user, level: res.level }));
          setLoggedIn(true); // <-- update loggedIn state in parent component
          localStorage.setItem(
            "user",
            JSON.stringify({ ...user, level: res.level })
          );
          navigate(-1);
        });
      })
      .catch((error) => {
        if (error.code === "auth/wrong-password") {
          setPasswordError("Incorrect password");
        } else {
          const errorCode = error.code;
          const errorMessage = error.message;
        }
      });
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleRecoverPasswordClick = (email) => {
    sendPasswordResetEmail(email);
  };

  return (
    <>
      <main className="centered-container">
        <section className="loginSection">
          <div className="loginDiv">
            <h1 className="loginTitle"> Login </h1>
            <p className="loginSubtitle">
              Good to see you again! <br /> Insert your email and password to
              login.
            </p>
            <form className={"formContainer"}>
              <div className="formDiv">
                <label className="emailLabel" htmlFor="email-address">
                  Email
                </label>
                <input
                  className="loginInput"
                  id="email-address"
                  name="email"
                  type="email"
                  required
                  placeholder="Email address"
                  onChange={handleEmailChange}
                />
                <p className="loginInsert">
                  Insert the Capgemini or Sogeti email that you used during
                  registration
                </p>
                {emailError && <p className="email-error">{emailError}</p>}
              </div>
              <div className="formDiv">
                <label className="passwordLabel" htmlFor="password">
                  Password
                </label>
                <input
                  className="loginInput"
                  id="password"
                  name="password"
                  type="password"
                  required
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                {passwordError && (
                  <p className="email-error">{passwordError}</p>
                )}
              </div>
              <NavLink to="/resetpassword" className="resetPassword">
                Forgot your password?
              </NavLink>
              <div class="login-button-container">
                <Button buttonStyle="blue" text="Login" onClick={onLogin} />
              </div>
            </form>
          </div>
          <div className="signupDiv">
            <h1 className="signUpTitle">Are you not part of RIOT Labs yet?</h1>
            <p className="signUpSubtitle">
              Do you have a fantastic idea, want contribute to one of our
              ongoing <br /> projects or just be part of an amazing team of
              professionals? <br />
              <br />
              <br />
              Sign up and join RIOT Labs now!
            </p>

            <p style={{ color: "black" }}>
              <div className="button-container">
                <Button
                  buttonStyle="pink-transparent"
                  text="Sign up now"
                  navigateTo="/signup"
                />
              </div>
            </p>
            <img className="signupImage" src={SignUp} alt="My PNG" />
          </div>
        </section>
      </main>
    </>
  );
};

export default Login;
